import { render } from "./AboutVitalia.vue?vue&type=template&id=f47dd438"
import script from "./AboutVitalia.vue?vue&type=script&lang=js"
export * from "./AboutVitalia.vue?vue&type=script&lang=js"

import "./AboutVitalia.vue?vue&type=style&index=0&id=f47dd438&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__